const FieldTypesEnum = {
  PureDataField: 'puredatafield',
  DataFieldWithDetails: 'datafieldwithdetails',
  FunctionField: 'functionfield',
  ActionButton: 'actionButton',
  Navigation: 'navigation',
  EmptySpace: 'EmptySpace',
  JustLabel: 'JustLabel',
};

export default FieldTypesEnum;
